/**
 * Make a label out of a model.
 * This is the implementation of the previous select.
 * This function is for compatibility purposes.
 */
export function makeLabel(model) {
	if (model.name !== undefined) {
		return model.name;
	}

	if (model.getName) {
		return model.getName();
	}

	return model.toString();
}

/**
 * Default search behavior for the select element.
 * This is the implementation of the previous select.
 * This function is for compatibility purposes.
 */
export function defaultSearch({ items }) {
	return (
		items.length >= 6 &&
		(({ item, searchText }) => {
			if (!item.match) return true;
			return item.match(searchText);
		})
	);
}

/**
 * Group items for the select element.
 * This is the implementation of the previous select.
 * This function is for compatibility purposes.
 */
export function groupItems({ items, getGroup, labelForGroup }) {
	const groups = new Map();
	const result = [];

	items.forEach((item) => {
		const groupKey = getGroup(item.value).toString();
		if (!groupKey) {
			result.push(item);
			return;
		}

		let group = groups.get(groupKey);
		if (!group) {
			group = { label: labelForGroup(groupKey), options: [] };
			groups.set(groupKey, group);
			result.push(group);
		}

		group.options.push(item);
	});

	return result;
}
